import React from 'react';
import {TextField, Button, Box, CircularProgress, Typography, Alert} from '@mui/material';
import {Link} from "react-router-dom";

interface ForgotFormProps {
    success: boolean | null;
    loading: boolean | null;
    error: string | null;
    onSubmit: (data: { email: string }) => void;
    buttonText: string;
}

const ForgotForm: React.FC<ForgotFormProps> = ({onSubmit, buttonText, loading, error, success}) => {
    const [email, setEmail] = React.useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit({email});
    };


    if (success === true) {
        return (
            <Box component="form" onSubmit={handleSubmit} sx={{mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Typography component="h1" variant="h5" sx={{textAlign: 'center', mb: 3}}>
                    Код для восстановления отправлен на почту
                </Typography>
                <Link to="/login">Вернуться к авторизации</Link>
            </Box>
        );
    }

    return (
        <Box component="form" onSubmit={handleSubmit}  sx={{width: '100%'}}>
            <Box component="form" onSubmit={handleSubmit} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Typography component="h1" variant="h5">
                    Восстановление пароля
                </Typography>

            </Box>
            <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />

            {loading === true ?
                <Box sx={{mt: 2, mb: 2, display: 'flex', justifyContent: 'center', height: 50}}>
                    <CircularProgress  style={{color: '#3a485b'}}/>
                </Box>
                :
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{mt: 2, mb: 1, height: 50, background: '#3a485b'}}
                >
                    {buttonText}
                </Button>
            }

            {error && <Alert severity="error" sx={{width: "100%", boxSizing: 'border-box', mt: 0, mb: 2}}>{error}</Alert>}

            <Box component="form" onSubmit={handleSubmit} sx={{mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Link to="/login">Войти</Link>

            </Box>

        </Box>
    );
};

export default ForgotForm;